import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import AuthCard from "@/components/auth/AuthCard";
import { UserType } from "@/types/user";
import { useLanguage } from "@/context/LanguageContext";
import { commonAuthLabels } from "@/i18n";

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultUserType?: UserType;
}

const AuthDialog = ({
  open,
  onOpenChange,
  defaultUserType,
}: AuthDialogProps) => {
  const { language } = useLanguage();
  const authLabels = commonAuthLabels(language);

  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-[95vw] sm:max-w-md max-h-[90vh] overflow-auto mt-4">
      <DialogHeader>
        <DialogTitle>{authLabels.loginRequired || "Login required"}</DialogTitle>
        <DialogDescription>
          {authLabels.loginRequiredDescription || "You need to be logged in to perform this action."}
        </DialogDescription>
      </DialogHeader>
      <div className="w-full max-w-full">
        <AuthCard isDialog={true} defaultUserType={defaultUserType} />
      </div>
    </DialogContent>
  </Dialog>
  );
};

export default AuthDialog;
